import { initialSummary } from "Data/sharedSafari";
import React, { createContext, useContext, useReducer, useMemo } from "react";
import { operatorProfileReducer } from "reducers/operatorProfileReducer";

// Create context
export const OperatorProfileContext = createContext();

// Initial state
const initialState = {
  // Profile view of the logged-in user
  operatorProfileView: null,
  loadingOpProfile: true,
  opProfileError: '',
  //set active tab
  activeTab: 'sharedsafari',
  //operator share safari
  opSharedSafari: [],
  summary: initialSummary,
  pageIndex: 1,
  opSharedSafariLoading: true,
  opSharedSafariError: '',

  //operator Package
  opPackage: [],
  summaryOp: initialSummary,
  pageIndexOp: 1,
  opPackageLoading: true,
  opPackageError: '',
  //operator Parks
  opParks: [],
  summaryParks: initialSummary,
  pageIndexParks: 1,
  opParkasLoading: true,
  opParksError: '',
  //operator Review
  opReviews: [],
  summaryReviews: initialSummary,
  pageIndexReviews: 1,
  opReviewLoading: true,
  opReviewsError: '',
  //review Filters
  filters: {
    park_id: null,
    sort_by: 'newest'
  },

  //opertaor account setting
  operatorAccData: null,
  opAccLoading: true,
  opAccError: '',
  toggleForm: false,
  activeTabOp: 'profile-settings'
};

// Provider
const OperatorProfileProvider = ({ children }) => {
  const [state, dispatch] = useReducer(operatorProfileReducer, initialState);
  const contextValue = useMemo(() => ({
    ...state,
    operatorProfileDispatch: dispatch,
  }), [state]);

  return (
    <OperatorProfileContext.Provider
      value={contextValue}
    >
      {children}
    </OperatorProfileContext.Provider>
  );
};

// Custom hook
export const useOperatorProfileContext = () => useContext(OperatorProfileContext);

export default OperatorProfileProvider;
